var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divBox"},_vm._l((_vm.btns),function(item,idx){return _c('div',{key:idx,class:item.value === _vm.listType ? 'activeBtn' : 'defaultBtn',on:{"click":function($event){return _vm.btnChange(item)}}},[_vm._v(" "+_vm._s(item.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }